export module AdresseModels {
  export interface AddressSalutation {
    anredeID: number;
    mandant: string;
    anrede: string;
  }

  export interface AddressLetterSalutation {
    briefanredeID: number;
    mandant: string;
    briefanrede: string;
  }

  export interface AddressListElement {
    adressID: string;
    mandator: string;
    adressNo: number;
    shorname: string;
    firstName: string;
    lastName: string;
    salutation: string;
    letterHead: string;
    title: string;
    companyDescription: string;
    street1: string;
    street2: string;
    zip: string;
    city: string;
    country: string;
    phone01: string;
    phone02: string;
    phone03: string;
    phone04: string;
    email: string;
    inaktiv: boolean;
    parentAdressID: string;
  }

  export interface AnsprechPartnerListElement {
    adressID: string;
    adressNr: number;
    hauptAnsprechpartner: number;
    name: string;
    vorname: string;
    zuhanden: string;
    anrede: string;
    briefanrede: string;
    telefon: string;
    natel: string;
    email: string;
    homepage: string;
    ansprechInfo: string;
    pers: number;
    active?: boolean;
  }

  export interface AnsprechPartnerElement {
    adressID: string;
    adressNo: number;
    hauptAnsprechpartner: number;
    lastName: string;
    firstName: string;
    ansprechInfo: string;
    anrede: string;
    briefanrede: string;
    zuhanden: string;
    telefon: string;
    mobile: string;
    email: string;
    homepage: string;
    pers: number;
  }

  export interface Country {
    isoShort: string;
    isoNameInternational: string;
    isoNameNational: string;
    isoCurrency: string;
    isoLanguage: string;
  }

  export interface AdressStatus {
    id: number;
    mandantID: string;
    description: string;
    codeInsertDoc: number;
    codeInsertObject: number;
  }

  export interface DetailAdresseElement {
    adressID: string;
    mandator: string;
    adressNo: number;
    shortname: string;
    firstName: string;
    lastName: string;
    salutation: string;
    letterHead: string;
    title: string;
    companyDescription: string;
    street1: string;
    street2: string;
    zip: string;
    city: string;
    countryISOShort: string;
    country: Country;
    phone01: string;
    phone02: string;
    phone03: string;
    phone04: string;
    email: string;
    email2: string;
    fax: string;
    homepage: string;
    firstName2: string;
    lastName2: string;
    letterHead2: string;
    title2: string;
    adressStatus?: AdressStatus;
    name2First: number;
    status?: number;
    note: string;
  }

  export const EmptyDetailAdresseElement = (country: Country): AdresseModels.DetailAdresseElement => ({
    adressID: '',
    mandator: '',
    adressNo: 0,
    shortname: '',
    firstName: '',
    lastName: '',
    salutation: '',
    letterHead: '',
    title: '',
    companyDescription: '',
    street1: '',
    street2: '',
    zip: '',
    city: '',
    countryISOShort: 'CH',
    country: country,
    phone01: '',
    phone02: '',
    phone03: '',
    phone04: '',
    email: '',
    email2: '',
    fax: '',
    homepage: '',
    firstName2: '',
    lastName2: '',
    letterHead2: '',
    title2: '',
    name2First: 0,
    note: ''
})

  export interface AddressTypes {
    addressTypeNumber: number;
    description: string;
    shortname: string;
    copyFromAbove?: number;
  }

  /* Dieses Interface muss mit Adress-Kontroller des Webservices übereinstimmen!! */
  export interface ObjektListElement {
    typeNumber: number;
    objectNumber: string;
    description: string;
    statusdescription: string;
    createdBy: string;
    created: Date;
    customer_Lastname: string;
    note4: string;
    visible: boolean;
    addressType?: number;
    adressContact?: number;
    adressNumber?: number;
    objectType?: number;
    address: string;
    zipCode: string;
    town: string;
    datapath: string;
    modifiedBy?: string;
    modified?: Date;
    foreignOrder: string;
    foreignSubOrder: string;
    shortname: string;
    typeDescription: string;
    objectID: string;
    adressID?: string;
    contactID?: string;
    contact_Lastname: string;
    contact_Firstname: string;
    status?: number;
    archiveYear: string;
    customer_Firstname: string;
    status_SortOrder?: number;
  }

  export interface ObjektListField {
    dbField: string;
    titel: string;
    visible: boolean;
  }

  export interface Ort {
    country: string;
    zip: string;
    town: string;
    canton: string;
  }

  export interface AddressSearch {
    resultCount: number,
    offset: number,
    limit: number,
    addresses: AdresseModels.AddressListElement[]
  }
}
